module.exports = __webpack_public_path__ + "static/media/tour-produto-1.8930685b.png";